/*
 * Caribbean Spiced Cold Brew — landing page scripts
 * Scoped to .cs-landing root; no-ops on pages without it.
 * Ports prototype motion (reveal, stagger, nav-hide, hero parallax)
 * and wires real Shopify cart permalinks in place of the prototype's fake.
 */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('.cs-landing');
    if (!root) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // --- Scroll reveal
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('visible');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.15 });
      root.querySelectorAll('.reveal-on-scroll').forEach(function (el) { io.observe(el); });
    } else {
      // Fallback: show everything immediately
      root.querySelectorAll('.reveal-on-scroll').forEach(function (el) { el.classList.add('visible'); });
    }

    // --- Stagger children of grids
    root.querySelectorAll('.bgrid, .rgrid, .cards').forEach(function (group) {
      var kids = group.querySelectorAll('.reveal-on-scroll');
      kids.forEach(function (k, i) { k.style.transitionDelay = (i * 90) + 'ms'; });
    });

    // --- Nav show/hide on scroll
    var nav = root.querySelector('.cs-nav');
    if (nav) {
      var lastY = 0;
      window.addEventListener('scroll', function () {
        var y = window.scrollY;
        if (y > 120 && y > lastY) nav.style.transform = 'translateY(-100%)';
        else nav.style.transform = 'translateY(0)';
        lastY = y;
      }, { passive: true });
    }

    // --- Hero parallax (motion-gated)
    if (!reduceMotion) {
      var heroProduct = root.querySelector('.hero-stage .product');
      var heroHalo = root.querySelector('.hero-stage .halo');
      if (heroProduct || heroHalo) {
        window.addEventListener('scroll', function () {
          var y = window.scrollY;
          if (y < 900) {
            if (heroProduct) heroProduct.style.transform = 'translateY(' + (y * 0.15) + 'px)';
            if (heroHalo)    heroHalo.style.transform    = 'translateY(' + (y * 0.05) + 'px) scale(' + (1 + y * 0.0004) + ')';
          }
        }, { passive: true });
      }
    }

    // --- Product video: lazy-loaded looping autoplay (motion-gated)
    //
    // Source is set only when the video scrolls within ~400px of the viewport,
    // so the page above stays light. Mobile and desktop variants are swapped
    // by viewport width at activation time.
    var videos = root.querySelectorAll('video[data-cs-video]');
    if (videos.length) {
      var pickSrc = function (v) {
        var isMobile = window.matchMedia('(max-width: 768px)').matches;
        return isMobile ? v.getAttribute('data-src-mobile') : v.getAttribute('data-src-desktop');
      };

      var activate = function (v) {
        if (v.getAttribute('src')) return;
        var src = pickSrc(v);
        if (!src) return;
        v.setAttribute('src', src);
        v.load();
        var p = v.play();
        if (p && typeof p.catch === 'function') p.catch(function () { /* autoplay blocked: poster stays */ });
      };

      if (reduceMotion) {
        // Respect reduced-motion: leave the poster image visible, never load video.
        videos.forEach(function (v) {
          v.removeAttribute('autoplay');
          v.removeAttribute('loop');
          v.setAttribute('preload', 'none');
        });
      } else if ('IntersectionObserver' in window) {
        var vio = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            activate(e.target);
            vio.unobserve(e.target);
          });
        }, { rootMargin: '400px 0px', threshold: 0.01 });
        videos.forEach(function (v) { vio.observe(v); });
      } else {
        videos.forEach(activate);
      }
    }

    // --- Smooth-scroll anchors inside the section
    root.querySelectorAll('[data-cs-scroll]').forEach(function (el) {
      el.addEventListener('click', function (ev) {
        var targetId = el.getAttribute('data-cs-scroll');
        if (!targetId) return;
        var target = root.querySelector('#' + CSS.escape(targetId));
        if (!target) return;
        ev.preventDefault();
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      });
    });

    // --- Real cart permalink for offer CTAs
    //
    // Each .ocard button carries:
    //   data-variant-id="12345"             (required — 0 or empty means "not configured")
    //   data-selling-plan-id="67890"        (optional, subscribe tier only)
    //   data-channel="vitalsip"             (analytics tag, optional)
    //
    // On click: show "Added" feedback for ~1.8s, then navigate to /cart/<variant>:1
    // so Shopify adds it and returns to the cart page.
    root.querySelectorAll('.ocard button[data-variant-id]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId    = parseInt(btn.getAttribute('data-variant-id'), 10);
        var sellingPlan  = btn.getAttribute('data-selling-plan-id');

        if (!variantId || variantId <= 0) {
          // Not configured — avoid a broken redirect
          btn.textContent = 'Coming soon';
          btn.disabled = true;
          setTimeout(function () { btn.disabled = false; btn.textContent = btn.getAttribute('data-original-label') || 'Add to Cart'; }, 2000);
          return;
        }

        var origLabel = btn.getAttribute('data-original-label') || btn.textContent;
        btn.setAttribute('data-original-label', origLabel);
        btn.textContent = '✓ Added';
        btn.style.background = '#0D0A07';

        var params = new URLSearchParams();
        if (sellingPlan && /^\d+$/.test(sellingPlan) && parseInt(sellingPlan, 10) > 0) {
          params.set('selling_plan', sellingPlan);
        }

        setTimeout(function () {
          var qs = params.toString();
          window.location.href = '/cart/' + variantId + ':1' + (qs ? '?' + qs : '');
        }, 900);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
